import * as React from "react";
import useUserDateTime from "hooks/useUserDateTime";
import { PaginatedList, Spinner } from "components/common";
import { RowTitleButton } from "common/components";
import { FiltersRow, Table } from "security-app/components/common";
import { useGetSigmaRules } from "security-app/hooks/useSigmaAPI";
import { usePagination, useSetPagination } from "common/contexts";
import ListHeader from "./ListHeader";
import ListRows from "./ListRows";
const DFV = {
  visibleColumns: ["title", "level", "status", "last_run", "updated_at", "enabled"],
  renderRowTitle: (rule, editRule) => /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: () => editRule(rule) }, rule.title)
};
function List({
  visibleColumns = DFV.visibleColumns,
  displayRowActions = true,
  renderRowTitle = DFV.renderRowTitle,
  onlyMatchingSystemConfig = false,
  noSearchResultText = void 0
}) {
  const localPagination = usePagination();
  const setLocalPagination = useSetPagination();
  const { userTimezone } = useUserDateTime();
  const { rules, loadingRules, pagination } = useGetSigmaRules(localPagination, userTimezone, onlyMatchingSystemConfig);
  const onPageChange = (newPage, newPageSize) => {
    setLocalPagination({ ...localPagination, page: newPage, perPage: newPageSize });
  };
  const removeFilter = (filterKey) => (e) => {
    e.preventDefault();
    const auxFilters = { ...localPagination.filters };
    delete auxFilters[filterKey];
    setLocalPagination({ ...localPagination, filters: auxFilters });
  };
  return /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      activePage: localPagination.page,
      pageSize: localPagination.perPage,
      onChange: onPageChange,
      totalItems: pagination.total,
      useQueryParameter: false
    },
    /* @__PURE__ */ React.createElement(FiltersRow, { filters: localPagination.filters, labels: { updated_at: "Last Update" }, onRemove: removeFilter }),
    /* @__PURE__ */ React.createElement(Table, { condensed: true, hover: true, className: "table table-striped", "data-testid": "open-investigations-list" }, /* @__PURE__ */ React.createElement(ListHeader, { rules: rules || [], visibleColumns, displayRowActions }), /* @__PURE__ */ React.createElement("tbody", null, loadingRules ? /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { "aria-label": "Loading Sigma Rules", colSpan: visibleColumns.length }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Sigma Rules ..." }))) : /* @__PURE__ */ React.createElement(
      ListRows,
      {
        rules: rules || [],
        renderRowTitle,
        visibleColumns,
        displayRowActions,
        noSearchResultText
      }
    )))
  );
}
export default List;
